import React from 'react';
import PropTypes from 'prop-types';
import { AAMBeaconNotification } from 'components/shared/Beacon';
import { AAMBeaconButton} from 'components/shared/Beacon';
const BeaconNotification = ({
  title,
  type,
  description,
  ctalabel,
  ctaAction,
  ctaVariant,
  dismissable,
  variant,
  showActionZone
}) => {
  return (
    <div className="b-grid-item--12-col beacon-on-light">
      <AAMBeaconNotification
        dismissable={dismissable}
        variant={variant}
        type={type}>
        {title}
        {description && <span slot="description">{description}</span>}
        {showActionZone && (
          <span slot="action-zone">
            <AAMBeaconButton variant={ctaVariant} onBeaconEventClick={ctaAction} >{ctalabel}</AAMBeaconButton>
          </span>
        )}
      </AAMBeaconNotification>
    </div>
  );
};

BeaconNotification.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  description: PropTypes.node,
  ctalabel: PropTypes.string,
  ctaAction: PropTypes.func,
  dismissable: PropTypes.bool,
  variant: PropTypes.string,
  ctaVariant: PropTypes.string,
  showActionZone: PropTypes.bool
};

BeaconNotification.defaultProps = {
  title: '',
  description: null,
  ctalabel: '',
  ctaAction: null,
  dismissable: false,
  variant: 'standard',
  ctaVariant: 'secondary',
  type: 'inline',
  showActionZone: false
};

export default BeaconNotification;

